export const ROUTE_KEYS = {
  HOME: '/',
  BUSCAR_X_PAQUETES: '/buscarxpaquetes',
  CONSULTA: '/consulta',
  CONSULTA_DETALLE: '/consultaDetalle',
  PAQUETE: '/paquete',
  BUSCAR_X_VUELOS: '/buscarxvuelos',
  BUSCAR_X_VUELOS_RESERVA: '/buscarxvuelos/reservar',
};

export const QUERY_KEYS = {
  PACKAGE: 'package',
  BANNER: 'banner',
  PACKAGE_HOTELS: 'packageHotels',
  PACKAGE_CONFIGURATIONS: 'packageConfigurations',
  PACKAGE_INFORMATION: 'packageInformation',
  DEPARTURE_DATES: 'departureDates',
};

const DAY_SHORT = 'DD/MM/YYYY';
const TIME = 'HH:mm';
const TIME_MERIDIEM = 'LT';
const ISO = 'YYYY-MM-DD';
const NUMBER_MONTHNAME_YEAR = 'D [de] MMMM [de] YYYY';
const FLIGHT = 'DD ddd HH:mm';

export const DATE_KEYS = {
  FORMAT: {
    ISO,
    DAY_SHORT,
    FULL_TIME: `${DAY_SHORT} ${TIME}`,
    YEAR: 'YYYY',
    MONTH_YEAR: 'MMMM YYYY',
    TIME,
    TIME_MERIDIEM,
    NUMBER_MONTHNAME_YEAR,
    FLIGHT,
  },
};

export const TO_LOCAL_STRING_FORMAT_DATE_OPTIONS = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
};

export const KEY_KEYS = {
  BACKSPACE: 'Backspace',
};

export const dataDefaultValues = {
  data: [],
  error: false,
  isLoading: false,
};

export const COLOR_KEYS = {
  DEFAULT_BACKGROUND: '#8dd3bb',
  DEFAULT_TEXT: '#ffffff',
  DEFAULT_COLOR_GRAY: 'rgb(204, 204, 204)',
  CORAL: 'rgb(237, 108, 2)'
};

export const PAGINATION_KEYS = {
  PAGE: 1,
  PAGE_SIZE: 10,
};

export const SESSION_STORAGE_KEYS = {
  PACKAGE_ADVICE: 'packageAdvice',
  CACHE_STATUS: 'CACHE_STATUS'
};

export const PACKAGE_CARD_TABS_KEYS = {
  HOTELS: 'HOTELS',
  FLIGHTS: 'FLIGHTS',
};

export const FALLBACK_IMAGE =
  'https://res.cloudinary.com/travelit/image/upload/v1715261835/img-test/yhjpgrelyuu3z8ixbwao.jpg';

export const HOTELS_PAGE_FILTER_NAME = 'hotelsPage';

export const TAB_ITEMS = {
  ITINERARY: 'ITINERARY',
  INCLUDES: 'INCLUDES',
  HOTELS: 'HOTELS',
  RATES: 'RATES',
  DEPARTURE: 'DEPARTURE',
  DETAIL: 'DETAIL',
};

export const USDColor = '#118C4F';

export const CACHE_DEFAULTS = {
  DEFAULT_EXPIRATION_TIME: 10 * 60 * 1000, // 10 minutos en milisegundos
};